import React, { useEffect, useState } from 'react'
import { ProgressWrapper } from './style'
import wsHelperInstance from 'general/helpers/WebSocketHelper'

const ProgressCustom = ({
  title,
  inforExportReportFileDetail,
  setInforExportReportFileDetail = {},
  progressKey,
}) => {
  const [solved, setSolved] = useState(0)
  const [total, setTotal] = useState(100)
  const [titleStatus, setTitleStatus] = useState('Xuất dữ liệu')
  const key = progressKey ?? 'totalBaoCaoChiTiet'

  const ruleOfThree = (num1, num2) => {
    const proportion = (num2 * 100) / num1
    return Math.round(proportion * 10) / 10
  }

  const percentage = ruleOfThree(total, solved)

  const handleAdd = () => {
    if (solved < total) {
      setSolved((prevSolved) => prevSolved + 1)
    }
  }

  const closeSocket = () => {
    setTitleStatus('Xuất dữ liệu')
    wsHelperInstance.closeSocket('16')
    setInforExportReportFileDetail({ disable: false })
  }

  const setTotalBaoCaoChiTiet = () => {
    const inputElement = document.getElementById(key)?.value
    if (inputElement) {
      setTotal(inputElement)
    }
  }

  const setTotalRunBaoCaoChiTiet = () => {
    const inputElement = document.getElementById(`${key}Run`)?.value
    if (inputElement) {
      setSolved(inputElement)
    }
  }

  const setTitleBaoCaoDetailsReset = () => {
    setTitleStatus('Xuất dữ liệu')
  }

  const handleDataFile = () => {
    setTitleStatus('Đang xử lý File')
  }

  useEffect(() => {
    if (!inforExportReportFileDetail?.disable) {
      setSolved(0)
      // setTitleStatus('Xuất dữ liệu')
    }
  }, [inforExportReportFileDetail?.disable])

  return (
    <>
      {inforExportReportFileDetail?.disable && (
        <ProgressWrapper percentage={percentage}>
          <div className="status-info">
            <h5 className="title">
              {titleStatus}: {title}
            </h5>
            <div className="bar-wrap">
              <span className="percentagenumber">{percentage}%</span>
              <div className="bar" style={{ width: `${percentage}%` }}></div>
            </div>
            <p className="line" style={{ display: 'none' }}>
              Solved puzzles: <span className="number">{solved}</span>
            </p>
          </div>
          <div className="btn-wrap" style={{ display: 'none' }}>
            <button className="btn" onClick={handleAdd} id={`increase${key}`}>
              +
            </button>
            <button className="btn" onClick={closeSocket} id={`${key}Close`}>
              close
            </button>
            <input id={key} />
            <button
              className="btn"
              onClick={setTotalBaoCaoChiTiet}
              id={`set${key}`}
            >
              setTotalBaoCaoChiTiet
            </button>
            <input id={`${key}Run`} />
            <button
              className="btn"
              onClick={setTotalRunBaoCaoChiTiet}
              id={`setTotalRun${key}`}
            >
              setTotalRunBaoCaoChiTiet
            </button>
            <button
              className="btn"
              onClick={() => {
                setTotal(0)
              }}
              id={`setResetSolved${key}`}
            >
              close
            </button>
            <button
              className="btn"
              onClick={handleDataFile}
              id={`handleDataFileDetails${key}`}
            >
              handle
            </button>
            <button
              className="btn"
              onClick={setTitleBaoCaoDetailsReset}
              id={`setTitle${key}Reset`}
            >
              setTitleBaoCaoDetailsReset
            </button>
          </div>
        </ProgressWrapper>
      )}
    </>
  )
}

export default ProgressCustom
